// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__xT7cW","items":"NavBar_items__N0X4c"};